export default __webpack_public_path__ + "static/media/checkbox-checked.f6d3df0a.svg";